import React, { useEffect, useState } from 'react'
import { Blacked, Icon } from '../organism/Navigation/styles'
import { TiArrowSortedDown } from 'react-icons/ti'
import { FaChevronLeft } from 'react-icons/fa6'
import {
	ManageNote,
	ManageStyleModalMain,
	NoteTable,
	TableHeader,
	NoteHeader,
	TextArea,
	NoteTableWrapper,
	MobileTable,
} from './styles/modalStyles'
import { useManageLearningNote } from '../hooks/LearningNote'
import { AddManageLearningNote } from './AddManageLearningNote'
import { useToken } from 'app/hooks'
import API from 'utils/api'
import { message, Radio } from 'antd'
import { useGetUserClass } from '../hooks/GetClassList'
import { printLearningNote } from 'utils/print-lecture'

export const ManageMultiStyleModal = ({
	selectStudentNote,
	setManageSt,
	editNoteIndex,
	handleWriteClick,
	setIsWrite,
}) => {
	const { data: token } = useToken()
	const { UserClassData } = useGetUserClass(selectStudentNote?.studentId || selectStudentNote?.id)

	const now = new Date()
	const year = now.getFullYear()
	const month = now.getMonth() + 1
	const recentYears = Array.from({ length: 5 }, (_, idx) => year - idx)
	const [selectedYear, setSelectedYear] = useState(year)
	const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1)
	const [isMonthDropdownOpen, setIsMonthDropdownOpen] = useState(false)
	const [selectedLectureId, setSelectedLectureId] = useState(null)

	// Set first lecture as selected when data loads
	useEffect(() => {
		if (UserClassData && UserClassData.length > 0 && !selectedLectureId) {
			setSelectedLectureId(UserClassData[0].id)
		}
	}, [UserClassData, selectedLectureId])

	const handleMonthSelect = (month: number) => {
		setSelectedMonth(month)
		setIsMonthDropdownOpen(false)
	}

	const handleMonthChange = (delta: number) => {
		let newMonth = selectedMonth + delta
		let newYear = selectedYear

		if (newMonth < 1) {
			newMonth = 12
			newYear -= 1
		} else if (newMonth > 12) {
			newMonth = 1
			newYear += 1
		}
		setSelectedMonth(newMonth)
		setSelectedYear(newYear)
	}

	const selectedLecture = UserClassData?.find(lecture => lecture.id === selectedLectureId)

	return (
		<ManageStyleModalMain>
			<Blacked onClick={() => setManageSt(false)} />
			<ManageNote className={'ManageNote'}>
				<NoteHeader className="learningNoteHeader">
					<div className="leftBtns">
						<Icon
							onClick={() => setManageSt(false)}
							style={{
								width: '24px',
								height: '24px',
								color: '#666666',
							}}>
							<FaChevronLeft />
						</Icon>
					</div>
					<div className="title" onClick={() => setIsMonthDropdownOpen(!isMonthDropdownOpen)}>
						<select
							className="yearSelect"
							value={selectedYear}
							onClick={e => e.stopPropagation()}
							onChange={e => {
								e.stopPropagation()
								setSelectedYear(Number(e.target.value))
								setIsMonthDropdownOpen(false)
							}}>
							{recentYears.map(y => (
								<option key={y} value={y}>
									{y}년
								</option>
							))}
						</select>
						<p>{selectStudentNote?.name}</p>
						<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
							<button
								onClick={e => {
									e.stopPropagation()
									handleMonthChange(-1)
								}}
								style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '14px' }}>
								&lt;
							</button>
							<span>{selectedMonth}월</span>
							{selectedYear === year && selectedMonth === month ? null : (
								<button
									onClick={e => {
										e.stopPropagation()
										handleMonthChange(1)
									}}
									style={{
										background: 'none',
										border: 'none',
										cursor: 'pointer',
										fontSize: '14px',
									}}>
									&gt;
								</button>
							)}
						</div>
						{isMonthDropdownOpen && (
							<div className="selectMonth">
								{[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(m => (
									<p
										key={m}
										onClick={() => handleMonthSelect(m)}
										style={{
											backgroundColor: selectedMonth == m ? '#F78B85' : '',
											color: selectedMonth == m ? '#FFF' : '',
										}}>
										{m}월
									</p>
								))}
							</div>
						)}
						<p>학습일지</p>
						<p>
							<TiArrowSortedDown />
						</p>
					</div>
				</NoteHeader>
				<div
					className="lectureTabs"
					style={{
						display: 'flex',
						gap: '8px',
						padding: '16px 20px 0',
						borderBottom: '1px solid #F0F0F0',
						overflowX: 'auto',
						flexWrap: 'wrap',
					}}>
					{UserClassData?.map(lecture => (
						<button
							key={lecture.id}
							onClick={() => setSelectedLectureId(lecture.id)}
							style={{
								padding: '8px 16px',
								borderRadius: '4px 4px 0 0',
								border: 'none',
								backgroundColor: selectedLectureId === lecture.id ? '#F78B85' : '#F5F5F5',
								color: selectedLectureId === lecture.id ? '#FFF' : '#666666',
								cursor: 'pointer',
								fontSize: '14px',
								fontWeight: selectedLectureId === lecture.id ? '600' : '400',
								transition: 'all 0.2s',
								whiteSpace: 'nowrap',
							}}>
							{lecture.name}
						</button>
					))}
				</div>
				<div className="modalMain" style={{ paddingTop: '10px' }}>
					{selectedLecture && (
						<LectureSection
							key={selectedLecture.id}
							lecture={selectedLecture}
							selectStudentNote={selectStudentNote}
							selectedMonth={selectedMonth}
							selectedYear={selectedYear}
							year={year}
							token={token}
							handleWriteClick={handleWriteClick}
							editNoteIndex={editNoteIndex}
							setIsWrite={setIsWrite}
							setManageSt={setManageSt}
						/>
					)}
				</div>
			</ManageNote>
		</ManageStyleModalMain>
	)
}

// Separate component for each lecture's section
const LectureSection = ({
	lecture,
	selectStudentNote,
	selectedMonth,
	selectedYear,
	year,
	token,
	handleWriteClick,
	editNoteIndex,
	setIsWrite,
	setManageSt,
}) => {
	const {
		ManageLearningNoteData,
		mutate: LearningNoteMutate,
		changeDateFilter,
	} = useManageLearningNote(lecture?.id, selectStudentNote?.studentId || selectStudentNote?.id)
	const LearningNote = ManageLearningNoteData?.filter(it => it.type === 1) || []
	const monthNote = ManageLearningNoteData?.filter(it => it.type === 2) || []

	const [isAdd, setIsAdd] = useState(false)
	const [isAddMobile, setIsAddMobile] = useState(false)
	const [isFix, setIsFix] = useState(false)
	const [editingIndex, setEditingIndex] = useState(null)
	const [fixContent, setFixContent] = useState('')
	const [fixHomework, setFixHomework] = useState()
	const [fixMemo, setFixMemo] = useState()
	// -1 means "not selected" (UI shows '-')
	const [fixPrevHomeworkDone, setFixPrevHomeworkDone] = useState<number>(-1)
	const [fixMonthNote, setFixMonthNote] = useState(monthNote[0]?.content || '')

	const now = new Date()
	const month = now.getMonth() + 1
	const day = now.getDate()
	const sliceYear = year.toString()?.slice(-2)
	const formattedMonth = month < 10 ? `0${month}` : month
	const formattedDay = day < 10 ? `0${day}` : day
	const hours = now.getHours().toString().padStart(2, '0')
	const minutes = now.getMinutes().toString().padStart(2, '0')
	const formattedTime = `${year}-${formattedMonth}-${formattedDay} ${hours}:${minutes}`

	const [dateArrangeData, setDateArrangeData] = useState('')
	const [monthNoteDate, setMonthNoteDate] = useState('')
	const [todayMonthNoteDate, setTodayMonthNoteDate] = useState('')

	const apiurl = '/dashboard/lecture/' + lecture?.id + '/report/'

	useEffect(() => {
		const today = new Date()
		today.setFullYear(selectedYear)
		today.setMonth(selectedMonth - 1, 1)

		const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate()
		const sliceYear = today.getFullYear().toString()?.slice(-2)
		const formattedMonth = (today.getMonth() + 1).toString().padStart(2, '0')
		const newFormattedMonthRange = `${sliceYear}-${formattedMonth}-01 ~ ${sliceYear}-${formattedMonth}-${lastDay}`

		setDateArrangeData(newFormattedMonthRange)
	}, [selectedMonth, selectedYear])

	useEffect(() => {
		// NOTE: do NOT use toISOString() here. It converts to UTC and can shift the date/month in KST (e.g. Jan 1st -> Dec 31st).
		const today = `${now.getFullYear()}.${String(now.getMonth() + 1).padStart(2, '0')}.${String(
			now.getDate()
		).padStart(2, '0')}`

		const hasTodayNote = ManageLearningNoteData?.some(note => {
			const noteDate = note.createdAt.split(' ')[0]
			return noteDate === today
		})
		if (hasTodayNote) {
			setIsWrite(prevState => {
				return [
					...prevState,
					{
						id: lecture?.id,
						student: selectStudentNote.studentId || selectStudentNote.id,
						value: true,
					},
				]
			})
		}

		setFixMonthNote(monthNote[0]?.content.length > 0 ? monthNote[0]?.content : '')
	}, [ManageLearningNoteData, lecture, selectStudentNote, setIsWrite])

	const handleSaveButtonClick = () => {
		if (monthNote.length === 0) {
			API.post(apiurl, token + '', {
				type: 2,
				studentIds: [selectStudentNote.studentId || selectStudentNote.id],
				createdAt: todayMonthNoteDate === monthNoteDate ? '' : monthNoteDate,
				content: fixMonthNote,
				homework: '',
				memo: '',
			})
				.then((res: any) => {
					if (res.result.success) {
						handleWriteClick(editNoteIndex)
						message.success('저장되었습니다')
						LearningNoteMutate()
					}
				})
				.catch((err: any) => {})
		} else {
			API.put(
				apiurl +
					monthNote[0]?.id +
					'?studentId=' +
					(selectStudentNote.studentId || selectStudentNote.id),
				token + '',
				{
					datas: {
						content: fixMonthNote,
						createdAt: todayMonthNoteDate === monthNoteDate ? '' : monthNoteDate,
						homework: '',
						memo: '',
					},
				}
			)
				.then((res: any) => {
					if (res.result.success) {
						handleWriteClick(editNoteIndex)
						message.success('저장되었습니다')
						LearningNoteMutate()
					}
				})
				.catch((err: any) => {})
		}
	}

	const handleFixBtnClick = idx => {
		setEditingIndex(idx)
		setIsFix(true)
		setFixContent(LearningNote[idx].content)
		setFixHomework(LearningNote[idx].homework)
		setFixMemo(LearningNote[idx].memo)
		const p = LearningNote[idx].prev_homework_done ?? LearningNote[idx].prevHomeworkDone
		setFixPrevHomeworkDone(p === undefined || p === null ? -1 : p ? 1 : 0)
	}

	const handleFixSaveClick = noteId => {
		API.put(
			apiurl + noteId + '?studentId=' + (selectStudentNote.studentId || selectStudentNote.id),
				token + '',
				{
					datas: {
						content: fixContent,
						createdAt: formattedTime,
						homework: fixHomework,
						memo: fixMemo,
						prevHomeworkDone: fixPrevHomeworkDone === -1 ? null : fixPrevHomeworkDone,
					},
				}
			)
			.then((res: any) => {
				if (res.result.success) {
					message.success('수정되었습니다')
					setIsFix(false)
					setEditingIndex(null)
					LearningNoteMutate()
				}
			})
			.catch((err: any) => {})
	}

	const handleDeleteBtnClick = noteId => {
		API.delete(
			apiurl + noteId + '?studentId=' + (selectStudentNote.studentId || selectStudentNote.id),
			token + '',
			{}
		)
			.then((res: any) => {
				if (res.result.success) {
					message.success('삭제되었습니다')
					LearningNoteMutate()
				} else {
					message.error(res?.result?.message || '삭제에 실패했습니다.')
				}
			})
			.catch((err: any) => {})
	}

	const saveFixContent = e => {
		setFixContent(e.target.value)
	}
	const saveFixHomework = e => {
		setFixHomework(e.target.value)
	}
	const saveFixMemo = e => {
		setFixMemo(e.target.value)
	}
	const saveFixMonthNote = e => {
		setFixMonthNote(e.target.value)
	}

	const handleKeyDown = e => {
		if (e.key === 'Enter' && !e.shiftKey) {
			e.preventDefault()
			setFixContent(prevContent => prevContent + '\n')
		}
	}

	useEffect(() => {
		// NOTE: do NOT use Date#toISOString(). It converts to UTC and can shift month in KST.
		const yearMonth = `${selectedYear}-${String(selectedMonth).padStart(2, '0')}`

		changeDateFilter(yearMonth)
		setMonthNoteDate(yearMonth)
		setTodayMonthNoteDate(formattedTime?.slice(0, 7))
	}, [selectedMonth, selectedYear])

	return (
		<div className="lectureSection" style={{ marginBottom: '40px' }}>
			<div className="tableWrapper">
				<TableHeader>
					<p>{lecture?.name}</p>
					<p>{dateArrangeData}</p>
					<div className="rightBtns" style={{ display: 'flex', gap: '8px' }}>
						<button
							style={{
								border: '1px solid #EFA44F',
								backgroundColor: '#FFF',
								color: '#EFA44F',
								borderRadius: '4px',
								padding: '5px 10px',
								cursor: 'pointer',
							}}
							onClick={() =>
								printLearningNote(
									LearningNote,
									monthNote,
									selectStudentNote,
									selectedMonth,
									lecture,
									dateArrangeData
								)
							}>
							인쇄
						</button>
						<button
							className="message"
							style={{
								border: '1px solid #EFA44F',
								backgroundColor: '#FFF',
								color: '#EFA44F',
								borderRadius: '4px',
								padding: '5px 10px',
								cursor: 'pointer',
							}}
							onClick={() => {
								if (window.confirm('문자전송을 하시겠습니까?')) {
									API.post('/dashboard/message', token + '', {
										type: 'report',
										studentId: selectStudentNote.studentId || selectStudentNote.id,
										lectureId: lecture?.id,
										date: `${selectedYear}-${String(selectedMonth).padStart(2, '0')}`,
									})
										.then((res: any) => {
											if (res.result.success) {
												message.success('문자전송이 완료되었습니다')
											} else {
												message.error(res?.result?.message || '문자전송에 실패했습니다.')
											}
										})
										.catch((err: any) => {})
								}
							}}>
							문자전송
						</button>
						<button
							style={{
								backgroundColor: '#F78B85',
								border: 'none',
								borderRadius: '4px',
								padding: '5px 10px',
								color: '#FFF',
								cursor: 'pointer',
							}}
							onClick={handleSaveButtonClick}>
							저장
						</button>
					</div>
				</TableHeader>
				<NoteTableWrapper>
					<NoteTable>
						<thead>
							<tr>
								<th style={{ minWidth: '80px' }}>회차</th>
								<th style={{ minWidth: '100px' }}>일자</th>
								<th style={{ width: '60%' }}>학습내용</th>
								<th style={{ width: '20%' }}>과제</th>
								<th style={{ minWidth: '80px' }}>전일 숙제</th>
								<th style={{ width: '20%' }}>비고</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{LearningNote?.map((it, idx) => (
								<tr key={idx} className="learningNote">
									<td>{idx + 1}</td>
									<td className="date">{it.createdAt}</td>
									<td>
										{editingIndex !== idx ? (
											it.content
										) : (
											<div>
												<textarea
													style={{
														width: '100%',
													}}
													className="contentInput"
													autoFocus
													value={fixContent}
													placeholder="학습내용 입력(필수) &#13;&#10;줄바꿈은 shift + Enter"
													onChange={saveFixContent}
													onKeyDown={handleKeyDown}
												/>
											</div>
										)}
									</td>
									<td>
										{editingIndex !== idx ? (
											it.homework
										) : (
											<textarea
												placeholder="과제 수정"
												value={fixHomework}
												onChange={saveFixHomework}
											/>
										)}
									</td>
									<td>
										{editingIndex !== idx ? (
											(it.prev_homework_done ?? it.prevHomeworkDone) == null ? '-' : (it.prev_homework_done ?? it.prevHomeworkDone) ? 'O' : 'X'
										) : (
											<Radio.Group
												value={fixPrevHomeworkDone}
												onChange={e => setFixPrevHomeworkDone(e.target.value)}
												options={[
													{ value: 1, label: 'O' },
													{ value: 0, label: 'X' },
													{ value: -1, label: '-' },
												]}
											/>
										)}
									</td>
									<td style={{ position: 'relative' }}>
										{editingIndex !== idx ? (
											it.memo
										) : (
											<input
												style={{ position: 'relative', top: -82 }}
												type="text"
												placeholder="비고 수정"
												value={fixMemo}
												onChange={saveFixMemo}
											/>
										)}
									</td>
									<td>
										{editingIndex !== idx ? (
											<div className="btns2">
												<button className="fixBtn" onClick={() => handleFixBtnClick(idx)}>
													수정
												</button>
												<button className="deleteBtn" onClick={() => handleDeleteBtnClick(it.id)}>
													삭제
												</button>
											</div>
										) : (
											<div className="btns2" style={{ position: 'relative', top: -82 }}>
												<button className="fixBtn" onClick={() => handleFixSaveClick(it.id)}>
													저장
												</button>
												<button
													className="deleteBtn"
													onClick={() => {
														setEditingIndex(null)
														setIsFix(false)
													}}>
													취소
												</button>
											</div>
										)}
									</td>
								</tr>
							))}
						</tbody>
					</NoteTable>
					{LearningNote?.map((it, idx) => (
						<MobileTable key={idx}>
							<div className="tableHeader">
								<p>{idx + 1}회차</p>
								<p>{it.createdAt}</p>
							</div>
							<div className="tableMain">
								<div className="content">
									<h1>
										학습
										<br />
										내용
									</h1>
									<p>{it.content}</p>
								</div>
								<div className="assignment">
									<h1>과제</h1>
									<p>
										{it.homework == '' ? (
											<textarea className="assignmentMobile" placeholder="내용작성" />
										) : (
											it.homework
										)}
									</p>
								</div>
							</div>
						</MobileTable>
					))}
				</NoteTableWrapper>
				<AddManageLearningNote
					isAdd={isAdd}
					setIsAdd={setIsAdd}
					isAddMobile={isAddMobile}
					setIsAddMobile={setIsAddMobile}
					selectLecture={lecture}
					selectStudentNote={selectStudentNote}
					formattedTime={formattedTime}
					todayMonthNoteDate={todayMonthNoteDate}
					monthNoteDate={monthNoteDate}
				/>
			</div>
			<div className="modalBottom">
				<TableHeader>
					<p style={{ fontSize: '16px' }}>월간 학습현황</p>
					<p>{monthNote?.length == 0 ? '' : `작성일 : ${monthNote[0]?.createdAt}`}</p>
				</TableHeader>
				<TextArea placeholder="내용작성" onChange={saveFixMonthNote} value={fixMonthNote} />
			</div>
			<div className="teacherArea">
				<p>담당 강사 : {lecture?.teacherNames?.join(', ')}</p>
			</div>
		</div>
	)
}

export default React.memo(ManageMultiStyleModal)
